/* AMB Bundles — pack length pickers.
   Loaded from layout/theme.liquid only when the product declares window.AMB_PACK,
   so every other page on the store is untouched and sections/main-product.liquid
   is not modified at all.

   Why this file takes the form over rather than adding inputs to it: the submit
   handler in amb-theme.js builds its payload by hand — {id, quantity} — and never
   serialises the form. Line-item properties added as markup would be accepted by
   the DOM and then silently dropped on the way to the cart. */
(function () {
  'use strict';

  var CFG = window.AMB_PACK;
  if (!CFG || !CFG.size || !CFG.lengths || !CFG.lengths.length) return;

  /* The theme already styles .amb-opt / .amb-opt__label / .amb-opt__grid / .amb-pill
     and drives the selected look off aria-checked. We reuse all of it so the pickers
     are the same control as every other option on the store, and only add what the
     theme has no rule for: the section heading, the error state, and the notes. */
  var CSS = '' +
    '.amb-pack{margin:22px 0 4px}' +
    '.amb-pack__head{font-family:inherit;font-size:12px;letter-spacing:.14em;' +
    'text-transform:uppercase;color:var(--accent-ink);font-weight:600;margin:0 0 14px;' +
    'padding-bottom:10px;border-bottom:1px solid #EFE2DC}' +
    '.amb-pack .amb-opt{margin-bottom:14px}' +
    '.amb-pack .amb-opt__label{margin-bottom:8px;text-transform:none;letter-spacing:.02em;' +
    'font-size:12.5px}' +
    '.amb-opt.is-missing .amb-pill{border-color:#D98BA0;background:#FFF6F6}' +
    '.amb-pack__hint{margin:4px 0 0;font-size:13px;color:#A3182B}' +
    '.amb-pack__note{margin:12px 0 0;font-size:12.5px;color:#9A857D}';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  ready(function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    if (form.querySelector('[data-pack-picker]')) return;   /* never double-render */

    var style = el('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    /* ---- build the pickers, using the theme's own option control ---- */
    var wrap = el('div', 'amb-pack');
    wrap.setAttribute('data-pack-picker', '');

    var head = 'Choose your ' + CFG.size + ' lengths';
    if (CFG.band) head += ' · ' + CFG.band;
    wrap.appendChild(el('div', 'amb-pack__head', head));

    var cols = CFG.lengths.length;
    var i;
    for (i = 1; i <= CFG.size; i++) {
      var group = el('div', 'amb-opt');
      group.setAttribute('data-pack-group', String(i));
      group.appendChild(el('div', 'amb-opt__label', 'Bundle ' + i));

      var grid = el('div', 'amb-opt__grid');
      grid.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)';

      CFG.lengths.forEach(function (L) {
        var v = String(L).trim();
        if (!v) return;
        var pill = el('label', 'amb-pill');
        pill.setAttribute('aria-checked', 'false');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'properties[Bundle ' + i + ']';
        input.value = v + '″';
        input.setAttribute('data-pack-input', '');
        pill.appendChild(input);
        pill.appendChild(document.createTextNode(v + '″'));
        grid.appendChild(pill);
      });

      group.appendChild(grid);
      wrap.appendChild(group);
    }

    var hint = el('p', 'amb-pack__hint',
      'Pick a length for all ' + CFG.size + ' bundles before adding to your bag.');
    hint.setAttribute('data-pack-hint', '');
    hint.hidden = true;
    wrap.appendChild(hint);
    wrap.appendChild(el('p', 'amb-pack__note',
      'Any mix of lengths in this band — the price is the same either way.'));

    /* must live INSIDE the form: these post as line-item properties */
    var idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.parentNode === form) form.insertBefore(wrap, idInput);
    else form.appendChild(wrap);

    /* ---- take the form over ----
       amb-theme.js bound its submit handler at parse time, before this file runs.
       Replacing the node with a clone drops every listener already on it, so there
       is exactly one handler and no race over which wins. The qty stepper is a
       delegated document listener and survives. */
    var fresh = form.cloneNode(true);
    form.parentNode.replaceChild(fresh, form);
    form = fresh;

    /* A single-variant pack still renders Shopify's placeholder option group -
       a lone "Default Title" pill under a TITLE heading. It selects nothing and
       reads as a broken control sitting right above the real pickers. */
    form.querySelectorAll('[data-option-index]').forEach(function (g) {
      var vals = [].slice.call(g.querySelectorAll('.amb-pill input')).map(function (x) { return x.value; });
      if (vals.length <= 1 && (!vals[0] || vals[0] === 'Default Title')) g.style.display = 'none';
    });

    var groups = [].slice.call(form.querySelectorAll('[data-pack-group]'));
    hint = form.querySelector('[data-pack-hint]');
    idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var qtyInput = form.querySelector('[name="quantity"]');

    /* The clone dropped amb-theme.js's variant-pill listeners along with its submit
       handler. Pack products are single-variant so there are no pills today, but a
       pack that ever gains a real option must not silently lose its picker. Scoped
       to [data-option-index] so it can never touch our own pills. */
    var vjson = form.querySelector('[data-variant-json]');
    var priceEl = form.querySelector('[data-price]');
    if (vjson) {
      var vdata = JSON.parse(vjson.textContent);
      var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };
      var syncVariant = function () {
        var opts = [];
        form.querySelectorAll('[data-option-index]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          opts[parseInt(g.getAttribute('data-option-index'), 10)] = c ? c.value : null;
        });
        form.querySelectorAll('[data-option-index] .amb-pill').forEach(function (pill) {
          pill.setAttribute('aria-checked', pill.querySelector('input').checked ? 'true' : 'false');
        });
        var m = vdata.filter(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
        if (!m) return;
        idInput.value = m.id;
        if (priceEl) priceEl.textContent = money(m.price);
        if (addBtn) {
          addBtn.disabled = !m.available;
          addBtn.textContent = m.available
            ? (addBtn.getAttribute('data-add-text') + ' · ' + money(m.price))
            : 'Sold out';
        }
      };
      form.querySelectorAll('[data-option-index] .amb-pill input').forEach(function (inp) {
        inp.addEventListener('change', syncVariant);
      });
      syncVariant();
    }

    function chosen(group) {
      var c = group.querySelector('input:checked');
      return c ? c.value : '';
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        /* the theme paints the selected pill off aria-checked, not :checked */
        group.querySelectorAll('.amb-pill').forEach(function (pill) {
          pill.setAttribute('aria-checked',
            pill.querySelector('input').checked ? 'true' : 'false');
        });
        group.classList.remove('is-missing');
        if (hint && groups.every(chosen)) hint.hidden = true;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var missing = groups.filter(function (g) { return !chosen(g); });
      if (missing.length) {
        missing.forEach(function (g) { g.classList.add('is-missing'); });
        if (hint) hint.hidden = false;
        missing[0].scrollIntoView({ block: 'center' });
        return;
      }

      var props = {};
      groups.forEach(function (g) {
        props['Bundle ' + g.getAttribute('data-pack-group')] = chosen(g);
      });

      var qty = parseInt((qtyInput || {}).value, 10) || 1;
      var original = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: qty, properties: props })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        })
        .then(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = original; }
          enrichDrawer();
          var toggle = document.querySelector('[data-cart-toggle]');
          if (toggle) toggle.click();            /* opens AND refreshes the drawer */
          else if (window.openCart) window.openCart();
        })
        .catch(function (err) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = original; }
          if (hint) { hint.hidden = false; hint.textContent = 'Could not add to your bag. Please try again.'; }
          if (window.console) console.error('[amb-pack]', err);
        });
    });

    /* The drawer is rendered by amb-theme.js from /cart.js and prints only the
       product and variant title, so the lengths she just chose would appear
       nowhere before checkout. Enrich it once, after it repaints. Fully
       defensive: if the markup is not what we expect nothing happens, and the
       cart page still lists the properties server-side. */
    function enrichDrawer() {
      var host = document.querySelector('[data-cart-items]');
      if (!host || !window.MutationObserver) return;
      var done = false;
      var obs = new MutationObserver(function () {
        if (done) return;
        done = true;
        obs.disconnect();
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var byKey = {};
          cart.items.forEach(function (it) { byKey[it.key] = it.properties || {}; });
          host.querySelectorAll('[data-remove]').forEach(function (rm) {
            var p = byKey[rm.getAttribute('data-remove')];
            var block = rm.parentNode;
            if (!p || !block || block.querySelector('[data-pack-props]')) return;
            var lines = Object.keys(p)
              .filter(function (k) { return p[k] && k.charAt(0) !== '_'; })
              .map(function (k) { return k + ': ' + p[k]; });
            if (!lines.length) return;
            var d = el('div', null, lines.join('  ·  '));
            d.setAttribute('data-pack-props', '');
            d.style.cssText = 'font-size:11.5px;color:#8A756E;margin:-4px 0 8px;line-height:1.5';
            block.insertBefore(d, rm);
          });
        }).catch(function () { /* cosmetic only - never block the sale */ });
      });
      obs.observe(host, { childList: true });
      setTimeout(function () { obs.disconnect(); }, 4000);
    }
  });
})();
